export const CREATE_MEDICINE_DETAILS = "CREATE_MEDICINE_DETAILS";
export const RETRIEVE_MEDICINE_DETAILS = "RETRIEVE_MEDICINE_DETAILS";
export const RETRIEVESINGLE_MEDICINE_DETAILS = "RETRIEVESINGLE_MEDICINE_DETAILS";
export const UPDATE_MEDICINE_DETAILS = "UPDATE_MEDICINE_DETAILS";
export const DELETE_MEDICINE_DETAILS = "DELETE_MEDICINE_DETAILS";


